import { styled } from "goober";
import { centeredPopupFeatures } from "../../lib/centeredPopup";
import { Button } from "../Button";
import { EmptyState } from "../EmptyState";

const Overlay = styled("div")`
  position: absolute;
  inset: 0;
  z-index: 2;
  background: var(--surface-primary);
`;

export function SignInPrompt({ url }: { url: string }) {
  return (
    <Overlay>
      <EmptyState
        iconName="key"
        iconSize={24}
        title="Sign in to view this page"
        description="This page uses single sign-on, which opens in a new window."
        action={
          <Button
            onClick={() =>
              window.open(
                url,
                "_blank",
                `popup,noopener,${centeredPopupFeatures(520, 640)}`
              )
            }
          >
            Sign in
          </Button>
        }
      />
    </Overlay>
  );
}
